/* eslint-disable camelcase */
import { GET_DROPDOWN_SUCCESS, GET_DROPDOWN_FAILURE } from '../actions';
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { convertObjectToQueryParams } from 'src/utils/util';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const getURLForDropDown = (dropDownName, value, search) => {
    // if (
    //     value && value.hasOwnProperty('sapPartnerId')
    // ) {
    //     dropDownName = 'physicianZGList';
    // }
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    switch (dropDownName) {
        case 'territories': {
            const params = convertObjectToQueryParams({
                searchParam: search,
                sapPartnerId: value,
                isTransferSet: true,
            });
            url += `/aardt/territories?isOrderCreation=true&${params}`;
            break;
        }
        case 'accounts': {
            const params = convertObjectToQueryParams(value);
            url += `/aardt/accounts?orderType=&${params}&isTransferSet=true`;
            break;
        }
        case 'districts':
            url += '/aardt/districts?isOrderCreation=true';
            break;
        case 'caseCoverageEmployees': {
            const case_params = convertObjectToQueryParams(value);
            url += `/order/surgery/casesupport?${case_params}`;
            break;
        }
        case 'procedureList':
            url += '/order/Surgery/procedure';
            break;
        case 'physicianList': {
            const physicain_parmas = convertObjectToQueryParams(value);
            // url += `/aardt/accountPhysicians?${physicain_parmas}`;
            url += `/order/surgery/physician?${physicain_parmas}`;
            break;
        }
        case 'physicianZGList': {
            const physicain_parmas = convertObjectToQueryParams(value);
            url += `/aardt/accountPhysician?${physicain_parmas}`;
            break;
        }
        case 'templates': {
            const resourceType = 'ORDER_TEMPLATE_A';
            const templateParams = convertObjectToQueryParams({
                ...value,
                resourceType: resourceType,
                templateType: value.orderType,
            });
            url += `/productTemplates/templateslist?${templateParams}`;
            break;
        }
        default:
            break;
    }
    return url;
};
export default function* getDropDown(action) {
    const value = action.payload.value;
    const url = getURLForDropDown(
        action.payload.dropDownName,
        action.payload.value,
        action.payload.searchParam,
        action.payload.salesOrg,
        action.payload.countryISOCode
    );
    try {
        const result = yield axios.get(url).then((response) => response.data);
        let dropDownResult = result[action.payload.dropDownName];
        if (action.payload.dropDownName === 'caseCoverageEmployees') {
            if (dropDownResult) {
                dropDownResult = dropDownResult
                    .map((item) => {
                        const caseCoverageName = `${
                            item.caseCoverageFirstName
                        } ${
                            item.caseCoverageLastName
                        } ${accountNumberZeroTrimmer(
                            item.caseCoverageCustomerId
                        )}`;
                        item.caseCoverageFormattedName = caseCoverageName;
                        return item;
                    })
                    .filter((element) => element.caseCoverageEmpId != 'Other');
            }
        } else if (action.payload.dropDownName === 'accounts') {
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const accountName = `${
                        item.accountName
                    } ${accountNumberZeroTrimmer(item.accountId)}`;
                    item.accountFormattedName = accountName;
                    item.filterValue = ` ${item.accountId} ${item.accountName} `;
                    return item;
                });
            }
        } else if (action.payload.dropDownName === 'templates') {
            dropDownResult = result.templateList || [];
        } else if (action.payload.dropDownName === 'physicianList') {
            if (dropDownResult) {
                const excludeOthersPhysicianList = dropDownResult.filter(
                    (item) =>
                        item?.physicianId !== 'sst_phy_other' &&
                        item?.physicianFirstName !== 'Other'
                );

                if (excludeOthersPhysicianList?.length > 0) {
                    dropDownResult = excludeOthersPhysicianList.map((item) => {
                        let physicanName = `${item.physicianFirstName} ${item.physicianLastName} ${item.surgeonNumber}`;
                        if (item?.physicianDisplayName) {
                            physicanName = `${
                                item.physicianDisplayName
                            }  ${accountNumberZeroTrimmer(item.physicianId)}`;
                        }
                        item.physicanFormattedName = physicanName;
                        item.filterValue = ` ${item.physicianId} ${item.physicanFormattedName} `;
                        return item;
                    });
                }
            }
        } else if (action.payload.dropDownName === 'territories') {
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    item.cfn = item.terrirotryName;
                    return item;
                });
            }
        }

        yield put({
            type: GET_DROPDOWN_SUCCESS,
            items: dropDownResult || [],
            name: action.payload.dropDownName,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            loadAll: value?.isLoadAll,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DROPDOWN_FAILURE,
            name: action.payload.dropDownName,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
